// доработать, если будут и другие данные
const DB_NAME = "CertStorageDB";
const STORE_NAME = "certificates";

export interface SavedData {
  privateKeyEncrypted: string;
  publicKey: string;
  certificateDate: string;
}

// Функция для инициализации базы данных
export const initDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onupgradeneeded = (event) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject("Ошибка при открытии IndexedDB");
  });
};

// Функция для сохранения данных в IndexedDB
export const saveToDB = async (userId: string, data: Record<string, string>) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  store.put(data, userId);
  return tx.oncomplete;
};

// Функция для получения данных из IndexedDB
export const getFromDB = async (userId: string): Promise<SavedData> => {
  const db = await initDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, "readonly");
    const store = tx.objectStore(STORE_NAME);
    const request = store.get(userId);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject("Ошибка при получении данных");
  });
};

// Функция для удаления данных из IndexedDB
export const deleteFromDB = async (userId: string) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  store.delete(userId);
  return tx.oncomplete;
};
